export default "__VITE_ASSET__jGJjI0ra__"